<template>
  <chat-widget-list></chat-widget-list>

  <Teleport to="body">
    <!-- EDITOR WRAPPER-->
    <div class="overlay-editor order-editor">
      <OrderEditItem v-if="orderSelected" @save="n => onSave(n)" @add="n => onAdd(n)" :selected="orderSelected">
      </OrderEditItem>
    </div>
    <!--END EDITOR WRAPPER-->

    <!-- EDITOR WRAPPER-->
    <div class="overlay-editor lead-editor">
      <LeadEditItem v-if="leadSelected" @save="n => onSaveLead(n)" @add="n => onAddLead(n)" :selected="leadSelected">
      </LeadEditItem>
    </div>
    <!--END EDITOR WRAPPER-->
  </Teleport>

  <Teleport to="body">
    <!-- Modal -->
    <div class="modal custom-modal large-modal" id="file-manager" style="opacity: 1;z-index: 1111111;" tabindex="-1"
      role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal"><span
                aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <FileManager></FileManager>
          </div>
          <div class="modal-footer">
            <button type="button" class="default-btn btn-gray" data-dismiss="modal" @click="closeModal">
              {{ $static('fm.btncancel', 'Закрити') }}
            </button>
            <button type="button" class=" default-btn btn-accent" @click="select" style="margin-left:20px">
              {{ $static('fm.btn1', 'Зберегти зміни') }}
            </button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
  </Teleport>

  <Teleport to="body">
    <!-- Modal -->
    <div class="modal custom-modal small-modal" id="confirm-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLongTitle">{{ $static('box.d-title', 'Підтвердити видалення') }}
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeConfirmModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            {{ $static('box.d-text', 'Видалені дані не вдасться відновити.') }}
          </div>
          <div class="modal-footer">
            <button type="button" class="waves-effect waves-light default-btn btn-gray" data-dismiss="modal"
              @click.prevent.stop="closeConfirmModal">
              {{ $static('box.cancel', 'Скасувати') }}
            </button>
            <button type="button" class="default-btn  btn-accent" @click.prevent.stop="confirmModal"
              style="margin-left:20px">
              {{ $static('box.confirm', 'Підтвердити') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>

  <Teleport to="body">
    <!-- Modal -->
    <div class="modal custom-modal" id="hello-modal" tabindex="-1" role="dialog" aria-hidden="true"
      data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeHelloModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h3 class="mt-3">{{
              $static(
                'box.hello-text',
                'Ласкаво просимо, щоб почати, встановіть токен телеграм робота, в налаштуваннях вашого магазину'
              )
            }}</h3>
          </div>
          <div class="modal-footer">
            <button type="button" class="default-btn btn-accent" @click="openSettings">
              {{ $static('box.hello-btn', 'Налаштування магазину') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>

  <AdminNav />

  <!-- HEADER PANEL-->
  <AdminHeader />
  <!-- END HEADER PANEL-->

  <!-- GLOBAL SECTION-->
  <div class="container-wrapper">
    <div class="content-wrapper">
      <router-view />
    </div>
  </div>

  <AdminFooter />

  <!-- END GLOBAL SECTION-->
  <div class="color-shapes" style="display: none;">
    <div class="shape-blur"></div>
    <img src="/images/rose-shape.svg" class="rose-shape">
    <img src="/images/violet-shape.svg" class="violet-shape">
  </div>
</template>

<script>
import LeadEditItem from '@/components/LeadEditItem';
import OrderEditItem from './OrderEditItem';
import AdminFooter from './AdminFooter';
// @ is an alias to /src
import FileManager from './AdminFileManager';
import AdminHeader from './AdminHeader';
import AdminNav from './AdminNav';
import ChatWidgetList from './ChatWidgetList';
import api from '@/api'

export default {
  name: 'AdminBox',
  components: {
    LeadEditItem,
    OrderEditItem,
    ChatWidgetList,
    AdminFooter,
    AdminHeader,
    AdminNav,
    FileManager
  },
  data() {
    return { orderSelected: undefined, leadSelected: undefined }
  },
  methods: {
    openSettings() {
      this.closeHelloModal();
      this.$router.push({ name: 'SettingsBasic' });
    },
    closeModal() {
      window.$('#file-manager').modal('hide');
      this.$store.commit('onFileSelect', undefined);

    },
    select() {
      window.$('#file-manager').modal('hide');
      let callback = this.$store.getters['onFileSelect'];
      if (callback) {
        // console.log('callback', callback);
        callback()
      }
      this.$store.commit('onFileSelect', undefined);
      console.log('reset state');
      window.resetState()
    },
    openOrder(item) {
      this.orderSelected = Object.assign({}, item);

      window.$('body').addClass('is-hidden');
      window.$('.back-blur').addClass('active');
      window.$('.order-editor').addClass('active');
    },
    openLead(item) {
      this.leadSelected = Object.assign({}, item);

      window.$('body').addClass('is-hidden');
      window.$('.back-blur').addClass('active');
      window.$('.lead-editor').addClass('active');
    },
    onSave(item) {
      if (window.onSaveOrder) {
        window.onSaveOrder(item)
      }
    },
    onSaveLead(item) {
      if (window.onSaveLead) {
        window.onSaveLead(item)
      }
    },
    onAdd(item) {
      if (window.onAddOrder) {
        window.onAddOrder(item)
      }
    },
    onAddLead(item) {
      if (window.onAddLead) {
        window.onAddLead(item)
      }
    },
    fetchSettings() {
      return api.get('/api/settings').then(response => response.data).then(data => {
        this.$store.commit('setSettings', data);
        return data
      })
    },
    confirmModal() {
      if (window.onModalConfirm) {
        window.onModalConfirm()
      }
      window.onModalConfirm = undefined;
      this.closeConfirmModal();
    },
    closeConfirmModal() {
      window.$('#confirm-modal').modal('hide')
    },
    closeHelloModal() {
      window.$('#hello-modal').modal('hide')
    },
    setStatusUpdate() {
      // Статусы заказа
      this.$store.commit('setStatusList', [
        { label: this.$static('slist.new', 'Нові'), value: 'new' },
        { label: this.$static('slist.process', 'Підтверджено'), value: 'process' },
        { label: this.$static('slist.progress', 'Відправлено'), value: 'progress' },
        { label: this.$static('slist.delivery', 'Отримано'), value: 'delivery' },
        { label: this.$static('slist.back', 'Повернення'), value: 'back' },
        { label: this.$static('slist.cancel', 'Відміна'), value: 'cancel' }
      ]);
      // Статусы заявки
      this.$store.commit('setLeadStatusList', [
        { label: this.$static('lead-slist.new', 'Нові'), value: 'new' },
        { label: this.$static('lead-slist.process', 'В обробці'), value: 'process' },
        { label: this.$static('lead-slist.complete', 'Завершені'), value: 'complete' },
        { label: this.$static('lead-slist.cancel', 'Відмінені'), value: 'cancel' }
      ]);
      // Статусы оплтаы
      this.$store.commit('payStatusList', [
        { label: this.$static('pstatus.npay', 'Очікує сплати'), value: 'npay' },
        { label: this.$static('pstatus.pay', 'Сплачено'), value: 'pay' },
        { label: this.$static('pstatus.cpay', 'Відміна'), value: 'cpay' }
      ]);
    }
  },
  mounted() {
    api.get('/api/ping')
    this.setStatusUpdate();
    this.$watchLangChange('setStatusUpdate', this.setStatusUpdate);

    let x = document.querySelector('.sidebar-menu a.active');
    while (x) {
      if (x.className === 'collapse') {
        window.$(x).collapse('show');
      }
      x = x.parentElement;
    }

    window.autoSelect = this.select;

    api.get('/api/plugin').then(response => response.data).then(data => {
      let list = data.filter(i => i.type === 'delivery');
      this.$store.commit('setDeliveryOptions', list.filter(i => i.status === 'active'));

      list = data.filter(i => i.type === 'payment');
      this.$store.commit('setPayments', list.filter(i => i.status === 'active'));
    });

    //  this.$notify({
    //                 title: 'Success',
    //
    //                 text : 'text123',
    //                 duration: 10000000
    //               });
    //
    //  this.$notify({
    //                 title: 'warn',
    //                 type: 'warn',
    //                 text : 'text123',
    //                 duration: 10000000
    //               });
    //
    //  this.$notify({
    //                 title: 'warn',
    //                 type: 'error',
    //                 text : 'text123',
    //                 duration: 10000000
    //               });
    // this.$notify({
    //               title: 'Info',
    //               type: 'info',
    //               text : 'text123',
    //               duration: 10000000
    //             });

    window.$('.back-blur').on('click', function () {
      window.$('body > .active').removeClass('active');
      window.$('body').removeClass('is-hidden');
    });
    window.openOrder = this.openOrder;
    window.openLead = this.openLead;

    this.fetchSettings().then(data => {
      if (!data.env.TELEGRAM_BOT_TOKEN) {
        window.$('#hello-modal').data('bs.modal', null);
        window.$('#hello-modal').modal({ backdrop: 'static', keyboard: false });
        window.$('#hello-modal').modal('show');
      }
    });

    $('#confirm-modal').on('hidden.bs.modal', function (e) {
      window.onModalConfirm = undefined;
    })

    window.resetState = () => { this.$store.commit('fm/left/resetSelected') }
  }
}
</script>

<style scoped>
.order-editor.active {
  z-index: 1040;
}

.lead-editor.active {
  z-index: 1040;
}
</style>